import React, { useEffect, useState } from 'react';
import {
  renderCheckboxes,
  renderDropdownWithoutLabel,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import {
  setEmbryologyBiopsyFiles,
  setEmbryologyData,
} from '../../../../actions/embryologyActions';
import { TextField } from '@mui/material';
import {
  completeFETCycleApi,
  downloadFETReport,
  fetchEmbryologyBiopsy,
  fetchEmbryologyTransferData,
  fetchFetCycle,
} from '../../../../api/embryologyApi';
import { toast } from 'sonner';
import {
  embryoTransferredDataRow,
  emptyBiopsyRow,
  thawingDetailsRow,
} from '../../../../reducers/embryologyReducer';
import {
  checkFileAvailabilityApi,
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../../api/patientApi';
import { deleteFileApi } from '../../../../api/fileApi';
import FileDocumentCard from '../../../../components/FileManager/FileDocumentCard';
import FileUploadCard from '../../../../components/FileManager/FileUploadCard';
import CustomTextField from '../../../../common/CustomTextField';
import DateComponent from '../../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';
import UIModal from '../../../../components/UIElements/UIModal';

import EmbryologyLiveBirthDetails from './EmbryologyLiveBirthDetails';
import EmbryologyClinicalPregDetails from './EmbryologyClinicalPregDetails';
import EmbryologyHormonalPregDetails from './EmbryologyHormonalPregDetails';
import EmbryologyET from './EmbryologyET';
import EmbryologyBasicTransferDetails from './EmbryologyBasicTransferDetails';
import EmbryologyDetailsWithEmbryologist from './EmbryologyDetailsWithEmbryologist';
import { calculateAge } from '../../../Registrationform/helpers/calculateAge';
import EmbryologyOocyteImageModal from './EmbryologyOocyteModal';
import { downloadFile, pollFileAvailability } from '../../../../api/utils';
const EmbryologyFrozenTransferDetails = ({
  selectedFetCycle,
  handleCompleteFETCycle,
}) => {
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    index: null,
  });

  const initialFrozenTransferState = {
    caseTypeOoctye: '',
    caseTypeSperm: '',
    thawingDetails: [{ ...thawingDetailsRow }],
    noOfStrawThawed: '',
    embryoTransferredData: [{ ...embryoTransferredDataRow }],
    noOfEmbThawed: '',
    noOfEmbSurvived: '',
    idAndStrawWitness: '',
    idAndStrawWitness2: '',
    thawingDoneBy: '',
    witness: '',
    date: '',
    time: '',
    media: '',
    transfer: '',
    surrogateName: '',
    surrogateAge: '',
    surrogateAadharNumber: '',
    surrogateMPI: '',
    additionalRequirement: [
      {
        name: 'LAH',
        label: 'LAH',
        checked: false,
      },
      {
        name: 'Embryo Glue',
        label: 'Embryo Glue',
        checked: false,
      },
      {
        name: 'Extended Culture',
        label: 'Extended Culture',
        checked: false,
      },
      {
        name: 'Others',
        label: 'Others',
        checked: false,
      },
    ],
    additionalRequirementOther: '',
    noOfEmbryoTransfered: '',
    gradeOfEmbryo: '',
    noOfEmbryoRefrozen: '',
    noOfEmbryoDiscarded: '',
    embryoRetentionAfterET: '',
    transferDetails: '',
    BloodOfTheCatheter: '',
    BloodOfTheCatheterReason: 'Inner',
    BloodOfTheCatherCheckbox: [
      {
        name: 'Inner',
        label: 'Inner',
        checked: false,
      },
      {
        name: 'Outer',
        label: 'Outer',
        checked: false,
      },
    ],
    EndometrialThickness: '',
    mucusOnTheCatheter: '',
    mucusOnTheCatheterReason: 'Inner',
    mucusOnTheCatherCheckbox: [
      {
        name: 'Inner',
        label: 'Inner',
        checked: false,
      },
      {
        name: 'Outer',
        label: 'Outer',
        checked: false,
      },
    ],
    embryologist: '',
    clinician: '',
    dishWitness: '',
    patientIdWitness: '',
    remarks: '',
    ETCathetar1: '',
    ETCathetar2: '',
    obturator: '',
    bhcgPositive: '',
    bhcgValue1: '',
    bhcgValue2: '',
    biochemicalPregnany: '',
    noOfSAC: '',
    clinicalPregnancyDetailsClinical: '',
    FHR: '',
    ectopic: '',
    ongoingPregnancy: '',
    clinicalPregnancyDetailsComments: '',
    noOfChildren: '',
    gender: [''],

    liveBirthDetailsComments: '',
  };

  const [imageModal, setImageModal] = useState({
    open: false,
    day: null,
    index: null,
    isFT: true,
  });

  const [completeModal, setCompleteModal] = useState({
    open: false,
  });

  const data = useSelector((state) => state.embryologyReducer);
  const embryoTransferDetails = useSelector(
    (state) => state.embryologyReducer.embryoFrozenTransferDetails,
  );

  const fetCycles = useSelector((state) => state.embryologyReducer.fetCycles);

  const dispatch = useDispatch();
  useEffect(() => {
    if (selectedFetCycle.data) {
      dispatch(
        setEmbryologyData('embryoFrozenTransferDetails', selectedFetCycle.data),
      );
    } else {
      dispatch(
        setEmbryologyData(
          'embryoFrozenTransferDetails',
          initialFrozenTransferState,
        ),
      );
    }
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(
      setEmbryologyData(
        `embryoFrozenTransferDetails.${name}`,
        value === ' ' ? '' : value,
      ),
    );

    if (name === 'transfer') {
      if (value === 'Self') {
        dispatch(
          setEmbryologyData(`embryoFrozenTransferDetails.surrogateName`, ''),
        );
        dispatch(
          setEmbryologyData(`embryoFrozenTransferDetails.surrogateAge`, ''),
        );
        dispatch(
          setEmbryologyData(
            `embryoFrozenTransferDetails.surrogateAadharNumber`,
            '',
          ),
        );
        dispatch(
          setEmbryologyData(`embryoFrozenTransferDetails.surrogateMPI`, ''),
        );
      }
    }
  };

  const handleAddRow = () => {
    const copyRows = [...embryoTransferDetails.thawingDetails];
    copyRows.push(thawingDetailsRow);
    dispatch(
      setEmbryologyData('embryoFrozenTransferDetails.thawingDetails', copyRows),
    );
  };
  const handleGenderChange = (e, i, n, index) => {
    const { name, value } = e.target;
    embryoTransferDetails.gender[index] = value === ' ' ? '' : value;
    dispatch(
      setEmbryologyData(
        `embryoFrozenTransferDetails.${name}`,
        embryoTransferDetails.gender,
      ),
    );
  };

  const setUploadedFiles = (files, index) => {
    console.log('files', files);
    const copyRows = embryoTransferDetails.thawingDetails.map((item) => ({
      ...item,
    }));
    console.log('object', index, copyRows[index]);
    console.log('copyRows', copyRows[index]['images']);
    copyRows[index]['images'].push(files);
    console.log('hehe', copyRows[index]['images']);

    dispatch(
      setEmbryologyData('embryoFrozenTransferDetails.thawingDetails', copyRows),
    );
  };

  const setDeleteFiles = (index) => {
    const copyRows = embryoTransferDetails.thawingDetails.map((item) => ({
      ...item,
    }));
    copyRows[index]['images'] = [];
    dispatch(
      setEmbryologyData('embryoFrozenTransferDetails.thawingDetails', copyRows),
    );
  };

  const handleRowInputChange = (e, index) => {
    const { name, value } = e.target;
    const copyRows = embryoTransferDetails.thawingDetails.map((item) => ({
      ...item,
    }));
    copyRows[index][name] = value;
    dispatch(
      setEmbryologyData('embryoFrozenTransferDetails.thawingDetails', copyRows),
    );
  };

  const handleTimeChange = (value, name) => {
    dispatch(setEmbryologyData(`embryoFrozenTransferDetails.${name}`, value));
  };

  const handleDeleteRow = (index) => {
    const copyRows = [...embryoTransferDetails.thawingDetails];
    copyRows.splice(index, 1);
    dispatch(
      setEmbryologyData('embryoFrozenTransferDetails.thawingDetails', copyRows),
    );
  };

  const handleDateChange = (day, name) => {
    dispatch(setEmbryologyData(`embryoFrozenTransferDetails.${name}`, day));
  };

  const handleDateChangeRow = (day, name, index) => {
    const copyRows = embryoTransferDetails.thawingDetails.map((item) => ({
      ...item,
    }));
    copyRows[index][name] = day;
    dispatch(
      setEmbryologyData('embryoFrozenTransferDetails.thawingDetails', copyRows),
    );
  };

  const handleAdditionalRequirementChange = (e, index) => {
    console.log(e.target.name, e.target.checked);
    const { checked } = e.target;
    const updatedCheckboxes = embryoTransferDetails.additionalRequirement.map(
      (item, idx) => (idx === index ? { ...item, checked } : item),
    );
    if (e.target.name === 'otherValue') {
      dispatch(
        setEmbryologyData(
          'embryoFrozenTransferDetails.additionalRequirementOther',
          e.target.value,
        ),
      );
    } else {
      dispatch(
        setEmbryologyData(
          `embryoFrozenTransferDetails.additionalRequirement`,
          updatedCheckboxes,
        ),
      );
    }
  };
  const fileTag = `Embryology-Frozen-${data.selectedPatientData.patient.id}`;
  const handleUpload = async (file, patientId, index) => {
    if (fileTag === 'Embryology-Frozen-')
      return toast.error('Failed to upload file');
    if (!patientId) return toast.error('Patient not created');

    return new Promise((resolve, reject) => {
      try {
        setLoading(true);

        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            fileTag,
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              setUploadedFiles({ fileTag: fileTag, file: data }, index);
              setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 800,
          },
        );
      } catch (err) {
        setLoading(false);
        toast.error('Failed to upload file');
      }
    });
  };
  const handleDownloadReport = async () => {
    try {
      setLoading(true);
      const res = await downloadFETReport(
        data.selectedPatientData.patient.id,
        selectedFetCycle.id,
      );
      console.log('res', res);
      if (res.data.result && res.data.result.file) {
        toast.success('Generated report. Downloading...');

        try {
          const presignedUrl = await pollFileAvailability(
            checkFileAvailabilityApi,
            res.data.result.file.bucketName,
            res.data.result.file.fileKey,
          );
          downloadFile(
            presignedUrl,
            data.selectedPatientData.patient.id,
            `FET-Report-${selectedFetCycle.id}.pdf`,
          );
          toast.success('Report is downloaded successfully');
        } catch (error) {
          console.error('Failed to get presigned URL:', error);
        } finally {
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error('Error generating report:', error);
    }
  };

  const handleCompleteFETCycleWithConfirmation = () => {
    setCompleteModal({ open: true });
  };

  const isCompleted = (cycleId) => {
    try {
      const cycle = fetCycles.find((cycle) => cycle.cycleId === cycleId);
      return cycle.isComplete;
    } catch (error) {
      return false;
    }
  };
  return (
    <div className="embryology-table">
      <h3 style={{ textAlign: 'center' }}>Frozen Embryo Transfer Sheet</h3>
      <div className="card">
        <div className="body" style={{ display: 'flex', gap: '10px' }}>
          <table
            cellPadding={'20px'}
            style={{ flexGrow: 1, padding: '0px 10px' }}
          >
            <tbody>
              <tr>
                <td>
                  Patient's Name:{' '}
                  <span className="ml-4">
                    {data.selectedPatientData.patient.firstName}{' '}
                    {data.selectedPatientData.patient.lastName}
                  </span>
                </td>
                <td>
                  Age:
                  <span className="ml-4">
                    {data.selectedPatientData.patient.age}
                  </span>
                </td>
                <td>
                  MPI:
                  <span className="ml-4">
                    {data.selectedPatientData.patient.upid}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  Partner's Name:{' '}
                  <span className="ml-4">
                    {data.selectedPatientData.patient.partner.firstName}
                  </span>
                </td>
                <td>
                  Age:
                  <span className="ml-4">
                    {data.selectedPatientData.patient.partner.dob
                      ? calculateAge(
                          dayjs(data.selectedPatientData.patient.partner.dob),
                        )
                      : '-'}
                  </span>
                </td>
                <td>
                  MPI:
                  <span className="ml-4">
                    {data.selectedPatientData.patient.upid}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <EmbryologyBasicTransferDetails
        handleDateChange={handleDateChange}
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
        handleTimeChange={handleTimeChange}
        handleAdditionalRequirementChange={handleAdditionalRequirementChange}
        isFrozen={true}
      />
      <button
        className="btn btn-primary"
        style={{ width: '200px', marginBottom: '20px' }}
        onClick={handleAddRow}
      >
        Add Row
      </button>

      <h3 style={{ textAlign: 'center' }}>Thawing Details</h3>
      <div className="card">
        <div className="text-center">
          <div
            className="body "
            style={{
              display: 'flex',
              overflowX: 'auto', // Enables horizontal scroll
              padding: '10px',
            }}
          >
            {/* Table 1 */}
            <table
              style={{
                flex: '0 0 auto', // Prevent table from shrinking or growing
                borderCollapse: 'collapse',
              }}
            >
              <caption
                style={{
                  fontWeight: 'bold',
                  fontSize: '18px',
                  marginBottom: '10px', // Space between caption and table
                  textAlign: 'center', // Centers the text
                  captionSide: 'top',
                }}
              >
                Cryopreservation Details
              </caption>
              <thead>
                <tr>
                  <th style={{ width: '20px' }}>CRYO Device No.</th>
                  <th style={{ width: '170px' }}>Date OF OPU</th>
                  <th style={{ width: '40px' }}>Day Of Embryo Culture</th>
                  <th style={{ width: '40px' }}>Embryo Grade</th>
                </tr>
              </thead>
              <tbody>
                {embryoTransferDetails.thawingDetails.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {renderInputFieldWithoutLabel(
                        'cryoDeviceNo',
                        row.cryoDeviceNo,
                        (e) => handleRowInputChange(e, index),
                      )}
                    </td>

                    <td>
                      <DateComponent
                        id="dateOfOpu"
                        selectedDate={
                          row.dateOfOpu ? dayjs(row.dateOfOpu) : null
                        }
                        handleDateChange={(date, dateString) =>
                          handleDateChangeRow(date, 'dateOfOpu', index)
                        }
                      />
                    </td>
                    <td>
                      {renderInputFieldWithoutLabel(
                        'dayOfEmbryoCulture',
                        row.dayOfEmbryoCulture,
                        (e) => handleRowInputChange(e, index),
                      )}
                      {/* <CustomTextField
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        value={row.dayOfEmbryoCulture}
                        name={'dayOfEmbryoCulture'}
                        onChange={(e) => handleRowInputChange(e, index)}
                        variant="outlined"
                        size="small"
                        fullWidth
                      /> */}
                    </td>

                    <td>
                      {renderInputFieldWithoutLabel('grade', row.grade, (e) =>
                        handleRowInputChange(e, index),
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Table 2 */}
            <table
              style={{
                flex: '0 0 auto', // Prevent table from shrinking or growing
                borderCollapse: 'collapse',
              }}
            >
              <caption
                style={{
                  fontWeight: 'bold',
                  fontSize: '18px',
                  marginBottom: '10px', // Space between caption and table
                  textAlign: 'center', // Centers the text
                  captionSide: 'top',
                }}
              >
                Post Thaw Details
              </caption>
              <thead>
                <tr>
                  <th style={{ width: '160px' }}>Date Of Thawing</th>
                  <th style={{ width: '30px' }}>Post-Thaw Survival</th>
                </tr>
              </thead>
              <tbody>
                {embryoTransferDetails.thawingDetails.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <DateComponent
                        id="dateOfThawing"
                        selectedDate={
                          row.dateOfThawing ? dayjs(row.dateOfThawing) : null
                        }
                        handleDateChange={(date, dateString) =>
                          handleDateChangeRow(date, 'dateOfThawing', index)
                        }
                      />
                    </td>
                    <td>
                      {renderDropdownWithoutLabel(
                        'postThawSurvival',
                        row.postThawSurvival,
                        [' ', 'yes', 'no'],
                        handleRowInputChange,
                        index,
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table
              style={{
                flex: '0 0 auto', // Prevent table from shrinking or growing
                borderCollapse: 'collapse',
              }}
            >
              <caption
                style={{
                  fontWeight: 'bold',
                  fontSize: '18px',
                  marginBottom: '10px', // Space between caption and table
                  textAlign: 'center', // Centers the text
                  captionSide: 'top',
                }}
              >
                <br></br>
              </caption>
              <thead>
                <tr>
                  <th style={{ width: '30px' }}>Extended Embryo Culture</th>
                </tr>
              </thead>
              <tbody>
                {embryoTransferDetails.thawingDetails.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {renderDropdownWithoutLabel(
                        'extendedEmbryoCulture',
                        row.extendedEmbryoCulture,
                        [' ', 'yes', 'no'],
                        handleRowInputChange,
                        index,
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table
              style={{
                flex: '0 0 auto', // Prevent table from shrinking or growing
                borderCollapse: 'collapse',
              }}
            >
              <caption
                style={{
                  fontWeight: 'bold',
                  fontSize: '18px',
                  marginBottom: '10px', // Space between caption and table
                  textAlign: 'center', // Centers the text
                  captionSide: 'top',
                }}
              >
                Details of Embryos
              </caption>
              <thead>
                <tr>
                  <th style={{ width: '80px' }}>Day</th>
                  <th style={{ width: '110px', height: '93px' }}>
                    Grade at FET
                  </th>
                  <th>Attach Images</th>
                  <th style={{ width: '140px' }}>Fate</th>
                </tr>
              </thead>
              <tbody>
                {embryoTransferDetails.thawingDetails.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {renderInputFieldWithoutLabel(
                        'embryoDay',
                        row.embryoDay,
                        (e) => handleRowInputChange(e, index),
                      )}
                    </td>
                    <td>
                      {renderInputFieldWithoutLabel(
                        'gradeAtFET',
                        row.gradeAtFET,
                        (e) => handleRowInputChange(e, index),
                      )}
                    </td>
                    <td>
                      <button
                        className="btn btn-primary"
                        style={{}}
                        onClick={() =>
                          setImageModal({
                            open: true,
                            day: 0,
                            index,
                            isFT: true,
                          })
                        }
                      >
                        {`View ${row.images.length} Image(s)`}
                      </button>
                    </td>
                    <td>
                      {renderDropdownWithoutLabel(
                        'fate',
                        row.fate,
                        [' ', 'EMBRYO TRANSFER', 'REFREEZE', 'DISCARDED'],
                        handleRowInputChange,
                        index,
                      )}
                    </td>
                    <td style={{ margin: 0, padding: 0 }}>
                      <button
                        style={{ marginTop: '-20px' }}
                        className="btn btn-danger"
                        disabled={
                          embryoTransferDetails.thawingDetails.length === 1
                        }
                        onClick={() => setConfirmModal({ open: true, index })}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="body">
            <table
              style={{
                flex: '0 0 auto', // Prevent table from shrinking or growing
                padding: '0px 10px',
                borderCollapse: 'collapse',
              }}
              cellPadding={'10px'}
            >
              <tbody>
                <tr>
                  <td>No. Of Straw Thawed</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={embryoTransferDetails.noOfStrawThawed}
                      name={'noOfStrawThawed'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                  <td>No. Of Emb. Thawed</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={embryoTransferDetails.noOfEmbThawed}
                      name={'noOfEmbThawed'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>

                  <td>No. Of Emb. Survived</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={embryoTransferDetails.noOfEmbSurvived}
                      name={'noOfEmbSurvived'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                </tr>
                <tr>
                  <td>ID & Straw Witness 1</td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'idAndStrawWitness',
                      embryoTransferDetails.idAndStrawWitness,
                      handleInputChange,
                    )}
                  </td>
                  <td>ID & Straw Witness 2</td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'idAndStrawWitness2',
                      embryoTransferDetails.idAndStrawWitness2,
                      handleInputChange,
                    )}
                  </td>

                  <td>Thawing Done By</td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'thawingDoneBy',
                      embryoTransferDetails.thawingDoneBy,
                      handleInputChange,
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Witness:</td>
                  <td colSpan={5}>
                    {renderInputFieldWithoutLabel(
                      'witness',
                      embryoTransferDetails.witness,
                      handleInputChange,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <h3 style={{ textAlign: 'center' }}>Embryo Transfer Details</h3>
      <EmbryologyDetailsWithEmbryologist
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
        handleDateChange={handleDateChange}
        handleTimeChange={handleTimeChange}
        isFrozen={true}
      />

      <EmbryologyET
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
      />

      <h3 style={{ textAlign: 'center' }}>PREGNANCY AND OUTCOME</h3>
      <EmbryologyHormonalPregDetails
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
      />

      <EmbryologyClinicalPregDetails
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
      />

      <EmbryologyLiveBirthDetails
        embryoTransferDetails={embryoTransferDetails}
        handleInputChange={handleInputChange}
        handleGenderChange={handleGenderChange}
      />
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <button className="btn btn-primary" onClick={handleDownloadReport}>
          Download FET Report
        </button>
        <button
          className="btn btn-primary"
          disabled={isCompleted(selectedFetCycle.id)}
          onClick={handleCompleteFETCycleWithConfirmation}
          style={{ marginLeft: '10px' }}
        >
          Complete FET Cycle
        </button>
      </div>
      <UIModal
        title="Please confirm?"
        body="Are you sure you want to delete this record?"
        proceedText="Confirm"
        cancelText="Cancel"
        show={confirmModal.open}
        onClose={() => setConfirmModal({ open: false, index: null })}
        onSave={() => {
          handleDeleteRow(confirmModal.index);
          setConfirmModal({ open: false, index: null });
        }}
      />

      <UIModal
        title="Are you sure to complete the FET cycle?"
        body="Once completed no further addition/modification will be possible."
        proceedText="Confirm"
        cancelText="Cancel"
        show={completeModal.open}
        onClose={() => setCompleteModal({ open: false })}
        onSave={() => {
          handleCompleteFETCycle(
            data.selectedPatientData.patient.id,
            selectedFetCycle.id,
          );
          setCompleteModal({ open: false });
        }}
      />

      {imageModal.open &&
        imageModal.day !== null &&
        imageModal.index !== null && (
          <EmbryologyOocyteImageModal
            show={imageModal.open}
            index={imageModal.index}
            day={imageModal.day}
            onClose={() => {
              setImageModal({
                open: false,
                index: null,
                day: null,
                isFT: true,
              });
            }}
            isFT={imageModal.isFT}
            setFilesHandler={(file) => setUploadedFiles(file, imageModal.index)}
            setDeleteFileHandler={() => setDeleteFiles(imageModal.index)}
          />
        )}
    </div>
  );
};

export default EmbryologyFrozenTransferDetails;
